import React, {useEffect} from 'react';
import {Flipped, Flipper} from 'react-flip-toolkit';
import {useVotingResults} from '../../common/useVotingResults';
import {getOptionColor} from '../../getOptionColor';
import Bar from './Bar/Bar';
import {calculateBarSize} from '../../calculateBarSize';
import stylesheet from './Graph.module.scss';

const Graph = props => {
    const {question, results} = props,
        options = props.options || question.options,
        [indexedResults, sum, max] = useVotingResults(results);

    return (
        <Flipper className={stylesheet.Graph} flipKey={options.map(option => option.id).join()}>
            {options.map((option, i) => (
                <Flipped key={option.id} flipId={option.id}>
                    {flippedProps => (
                        <Bar
                            color={getOptionColor(option.id)}
                            size={calculateBarSize(sum, indexedResults[option.id], max, options.length)}
                            flippedProps={flippedProps}
                        />
                    )}
                </Flipped>
            ))}
        </Flipper>
    );
};

export default Graph;
